<template>
  <div class="row">
    <div class="col-md-4">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing project-card"
      >
        <div class="card-body p-20 p-md-25 p-lg-30">
          <div
            class="mb-12 mb-md-15 mb-lg-20 d-flex justify-content-between align-items-center"
          >
            <div class="title d-flex align-items-center">
              <div class="ms-15">
                <h5 class="mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10">
                  Information Client
                </h5>
                <!-- <h5 class="mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10">
                  <router-link
                     : to="`/edit-customer/${colis.customer}`"
                    class="text-decoration-none text-black"
                  >
                    <b>Magasin </b> :  {{ colis.magasin_name }}
                  </router-link>
                </h5> -->
              </div>
            </div>
          </div>

          <ul class="info ps-0 mb-15 mb-md-20 mb-lg-30 list-unstyled">
            <li class="text-secondary fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Magasin : </span
              >
              {{ colis.magasin_name }}
            </li>
            <li class="text-secondary fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Client : </span
              >
              {{ colis.client_name }}
            </li>

            <li class="text-secondary fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Téléphone : </span
              >
              {{ colis.customer_phone }}
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-md-8">
      <div
        class="card mb-25 border-0 rounded-0 bg-white letter-spacing project-card"
      >
        <div class="card-body p-20 p-md-25 p-lg-30">
          <div
            class="mb-12 mb-md-15 mb-lg-20 d-flex justify-content-between align-items-center"
          >
            <div class="title d-flex align-items-center">
              <div class="ms-15">
                <h5 class="mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10">
                  Informations Colis
                </h5>
                <!-- <h5 class="mb-0 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-10">
                  <router-link
                     : to="`/edit-customer/${colis.customer}`"
                    class="text-decoration-none text-black"
                  >
                    <b>Magasin </b> :  {{ colis.magasin_name }}
                  </router-link>
                </h5> -->
              </div>
            </div>
          </div>

          <ul class="info ps-0 mb-15 mb-md-20 mb-lg-30 list-unstyled">
            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Code d'envoi : </span
              >
              {{ colis.code }}
            </li>

            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Destinataire : </span
              >
              {{ colis.receiver }}
            </li>
            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Téléphone : </span
              >
              {{ colis.phone }}
            </li>

            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Ville : </span
              >
              {{ colis.city_name }}
            </li>

            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Adresse : </span
              >
              {{ colis.adresse }}
              <template v-if="colis.quartier">
                - {{ colis.quartier?.name }}</template
              >
            </li>
            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Commentaire : </span
              >
              {{ colis.note }}
            </li>

            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Nature Produit : </span
              >
              {{ colis.product_nature }}
            </li>

            <li class="fs-md-15 fs-md-16 fw-semibold">
              <span
                class="text-muted fs-12 fs-md-13 text-uppercase fw-medium d-inline-block"
                >Crbt : </span
              >
              {{ colis.price }} {{ $devis }}
            </li>

            <li
              class="fs-md-15 fs-md-16 fw-semibold"
              v-if="colis.from_stock === 1"
            >
              <h6>
                <i class="flaticon-shopping-cart-2"></i>Colis de Stock</h6>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="col-12 mb-30">
      <template v-if="colis.products">
        <div class="table-responsive">
          <table class="table text-nowrap align-middle mb-0">
            <thead>
              <tr>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
                ></th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Produit
                </th>
                <th
                  scope="col"
                  class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
                >
                  Informations
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(product, index) in colis.products"  :key="index">
                <th class="shadow-none lh-1 fw-bold ps-0">
                  <img
                    v-if="product.product_pic"
                     :src="
                      product.product_pic ||
                      require('@/assets/images/NoImage.png')
                    "
                    width="60"
                    height="60"
                    class=""
                  />
                </th>
                <td class="shadow-none lh-1 fw-medium">
                  {{ product.product_name }}<br />
                  <b>{{ product.variant_name }} - {{ product.variant_ref }}</b>
                </td>

                <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                  <span><b>Quantité  :  </b>{{ product.qnty }}</span>
                  <span><b>Date  :  </b>{{ getDate(product.created_at) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import moment from "moment";
import { toRefs } from "vue";
import { watch } from "vue";
export default {
  name: "HistoryColis",

  props: {
    coliDetails: {
      type: Object,
      required: true,
    },
    isOpen: Boolean,
  },

  setup(props) {
    // keep reactivity
    const { coliDetails } = toRefs(props);

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    watch(
      coliDetails,
      (newVal) => {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("coliDetails updated:", newVal);
        }
      },
      { immediate: true }
    );

    return {
      colis: coliDetails,
      getDate,
    };
  },
};
</script>